import React, {Component} from 'react';
import {Typography} from "@mui/material";
import Box from "@mui/material/Box";
import AddIcon from '@mui/icons-material/Add';
import Button from "@mui/material/Button";
import GoalNewOrEditFormPopUp from "./Goals/GoalNewOrEditFormPopUp";
import {UrlBuilder} from "../../../core/url/UrlBuilder";
import CardActionArea from "@mui/material/CardActionArea";
import GoalCard from "./Goals/GoalCard";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";

class RoutineExerciseDetailBloopGoalsTab extends Component {
	constructor(props) {
		super(props);
		this.state = {
			routine: this.props.routine,
			exercise: this.props.exercise,
			isShowing: false,
			isGoalNewOrEditFormPopUpOpen: false,
		};
	}

	componentWillReceiveProps(nextProps, nextContext) {
		if (!nextProps.isShowing) return;

		this.setState({
			exercise: nextProps.exercise,
			isShowing: nextProps.isShowing,
		});
	}

	shouldComponentUpdate(nextProps) {
		return nextProps.isShowing || nextProps.exercise.routineExerciseId !== this.state.exercise.routineExerciseId;
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		this.props.updateSwipeableViewsHeightFunc();
	}

	openGoalNewOrEditFormPopUp = (isOpen, goalToEdit = null, shouldRefresh = true) => {
		this.setState({
			isGoalNewOrEditFormPopUpOpen: isOpen,
			goalToEdit: goalToEdit,
		});
		if (!isOpen && shouldRefresh && this.props.refreshParentFunc) {
			this.props.refreshParentFunc();
		}
	}

	deleteGoal = async (event, goal) => {
		event.preventDefault();

		await fetch(UrlBuilder.goals.goalsApi(goal.id), {
			method: 'DELETE',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
		}).then(() => this.openGoalNewOrEditFormPopUp(false, null, true));
	}

	renderGoalCards = () => {
		const goals = this.state.exercise.goals;

		if (!goals || goals.length === 0) {
			return (
				<Box sx={{ textAlign: 'center', py: 3 }}>
					<TrackChangesIcon sx={{ fontSize: 36, color: 'text.disabled', mb: 1 }} />
					<Typography variant="body2" sx={{ color: 'text.secondary', mb: 0.5 }}>
						No goals yet
					</Typography>
					<Typography variant="caption" sx={{ color: 'text.disabled' }}>
						Set a goal to track your progress on this exercise.
					</Typography>
				</Box>
			);
		}

		return (
			<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
				{goals.map(goal => (
					<CardActionArea
						key={goal.id}
						onClick={() => this.openGoalNewOrEditFormPopUp(true, goal)}
						sx={{ borderRadius: 2 }}
					>
						<GoalCard goal={goal} routine={this.state.routine} exercise={this.state.exercise} />
					</CardActionArea>
				))}
			</Box>
		);
	}

	render() {
		if (!this.state.isShowing) {
			return <div />;
		}

		const goals = this.state.exercise.goals ?? [];
		const activeGoalCount = goals.filter(g => !g.dateCompleted).length;
		const maxGoals = 3;

		return <>
			<GoalNewOrEditFormPopUp
				exercise={this.state.exercise}
				goal={this.state.goalToEdit}
				isOpen={this.state.isGoalNewOrEditFormPopUpOpen}
				deleteGoalFunc={this.deleteGoal}
				closeSelfFunc={(shouldRefresh) => this.openGoalNewOrEditFormPopUp(false, null, shouldRefresh)}
			/>

			<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
				<Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
					{goals.length > 0 ? `${activeGoalCount} active · ${goals.length - activeGoalCount} completed` : ''}
				</Typography>
				<Button
					variant="contained"
					color="secondary"
					size="small"
					onClick={() => this.openGoalNewOrEditFormPopUp(true)}
					startIcon={<AddIcon />}
					disabled={this.state.routine.isArchived || this.state.exercise.isArchived || activeGoalCount >= maxGoals}
					sx={{ textTransform: 'none', fontWeight: 600 }}
				>
					New Goal
				</Button>
			</Box>

			{this.renderGoalCards()}
		</>;
	}
}

export default RoutineExerciseDetailBloopGoalsTab;
